<template>
  <b-modal @hide="modalClose" ref="partnerModal" :title="outsourcing ? $t('外注先登録') : !form.id ? $t('取引先登録') : $t('取引先編集')" size="lg">
    <b-container fluid>
      <table class="table table-bordered my-3">
        <thead>
          <tr>
            <th colspan="9999" class="bg-light">
              {{ $t("取引先情報") }}
            </th>
          </tr>
        </thead>
        <tbody class="tbody">
          <tr>
            <th class="table-active text-left">
              {{ $t("国") }}
            </th>
            <td class="text-left">
              <select
                v-model="form.countryCode"
                class="form-control"
                id="exampleFormControlSelect1"
              >
                <template>
                  <option
                    v-for="(item, index) in country"
                    :key="index"
                    :value="item.code"
                  >{{ $t(item.name) }}</option>
                </template>
              </select>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              {{ $t("取引先名") }}
              <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
            </th>
            <td class="text-left" colspan="5">
              <input
                v-model="form.name"
                type="text"
                class="form-control"
                placeholder
              />
            </td>
          </tr>
          <tr v-if="form.countryCode === 'JP'">
            <th class="table-active text-left">{{ $t("カナ") }}</th>
            <td class="text-left" colspan="5">
              <input
                v-model="form.kana"
                type="text"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t("管理番号") }}</th>
            <td class="text-left" colspan="5">
              <input
                v-model="form.code"
                type="text"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              {{ $t("取引先グループ") }}
            </th>
            <td class="text-left" colspan="5">
              <select
                v-model="form.partnerGroupId"
                class="form-control"
                id="exampleFormControlSelect1"
              >
                <option></option>
                <option
                  v-for="(item, index) in groups"
                  :key="`group-${index}`"
                  :value="String(item.id)"
                  >{{ item.name }}</option
                >
              </select>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              {{ $t("郵便番号") }}
            </th>
            <td class="text-left" colspan="5">
              <input
                v-model="form.zipcode"
                type="text"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              <template v-if="form.countryCode === 'JP'">
                {{ $t('都道府県') }}
              </template>
              <template v-else>{{ $t('州') }}</template>
            </th>
            <td class="text-left" colspan="5">
              <select
                v-model="form.prefCode"
                name="pref"
                id="id_pref"
                class="form-control"
              >
                <option value></option>
                <template v-if="form.countryCode">
                  <option
                    v-for="(item, index) in pref[form.countryCode]"
                    :key="index"
                    :value="item.code"
                    >{{ $t(item.name) }}</option
                  >
                </template>
              </select>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              {{ $t("住所1") }}
            </th>
            <td class="text-left" colspan="5">
              <input
                v-model="form.address1"
                type="text"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              {{ $t("住所2") }}
            </th>
            <td class="text-left" colspan="5">
              <input
                v-model="form.address2"
                type="text"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t("住所3") }}</th>
            <td class="text-left" colspan="5">
              <input
                v-model="form.address3"
                type="text"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              {{ $t("TEL") }}
            </th>
            <td class="text-left" colspan="5">
              <input
                v-model="form.phoneNo"
                type="tel"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t("FAX") }}</th>
            <td class="text-left" colspan="5">
              <input
                v-model="form.faxNo"
                type="tel"
                class="form-control"
              />
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">
              {{ $t("締日種別") }}
            </th>
            <td class="text-left" colspan="5">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDayType"
                  class="form-check-input"
                  type="radio"
                  id="closingDayType1"
                  value="date"
                />
                <label class="form-check-label" for="closingDayType1">
                  {{ $t("日付") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDayType"
                  class="form-check-input"
                  type="radio"
                  id="closingDayType2"
                  value="eom"
                />
                <label class="form-check-label" for="closingDayType2">
                  {{ $t("月末") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDayType"
                  class="form-check-input"
                  type="radio"
                  id="closingDayType3"
                  value="each"
                />
                <label class="form-check-label" for="closingDayType3">
                  {{ $t("都度払い") }}
                </label>
              </div>
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">{{ $t("締日") }}</th>
            <td class="text-left" colspan="5">
              <input
                v-model.number="form.closingDay"
                type="number"
                class="form-control input wf-60"
              />
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">
              {{ $t("支払日種別") }}
            </th>
            <td class="text-left" colspan="5">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.payType"
                  class="form-check-input"
                  type="radio"
                  id="payType1"
                  value="dom"
                />
                <label class="form-check-label" for="payType1">
                  {{ $t("当月日付") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.payType"
                  class="form-check-input"
                  type="radio"
                  id="payType2"
                  value="eom"
                />
                <label class="form-check-label" for="payType2">
                  {{ $t("当月末") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.payType"
                  class="form-check-input"
                  type="radio"
                  id="payType3"
                  value="nmd"
                />
                <label class="form-check-label" for="payType3">
                  {{ $t("翌月日付") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.payType"
                  class="form-check-input"
                  type="radio"
                  id="payType4"
                  value="eonm"
                />
                <label class="form-check-label" for="payType4">
                  {{ $t("翌月末") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.payType"
                  class="form-check-input"
                  type="radio"
                  id="payType5"
                  value="each"
                />
                <label class="form-check-label" for="payType5">
                  {{ $t("都度") }}
                </label>
              </div>
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">{{ $t("支払日") }}</th>
            <td class="text-left" colspan="5">
              <input
                v-model.number="form.payDay"
                type="number"
                class="form-control input wf-60"
              />
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">{{ $t("決算月") }}</th>
            <td class="text-left" colspan="5">
              <input
                v-model.number="form.closingMonth"
                type="number"
                class="form-control wf-8"
              />
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">
              {{ $t("決算月締日種別") }}
            </th>
            <td class="text-left" colspan="5">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDateType"
                  class="form-check-input"
                  type="radio"
                  id="closingDateType1"
                  value="date"
                />
                <label
                  class="form-check-label"
                  for="closingDateType1"
                  >{{ $t("日付") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDateType"
                  class="form-check-input"
                  type="radio"
                  id="closingDateType2"
                  value="eom"
                />
                <label
                  class="form-check-label"
                  for="closingDateType2"
                  >{{ $t("月末") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDateType"
                  class="form-check-input"
                  type="radio"
                  id="closingDateType3"
                  value="each"
                />
                <label
                  class="form-check-label"
                  for="closingDateType3"
                  >{{ $t("都度払い") }}</label>
              </div>
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">
              {{ $t("決算月締日") }}
            </th>
            <td class="text-left" colspan="5">
              <input
                v-model.number="form.closingDate"
                type="number"
                class="form-control input wf-60"
              />
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">
              {{ $t("決算直後支払日種別") }}
            </th>
            <td class="text-left" colspan="5">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDatePayType"
                  class="form-check-input"
                  type="radio"
                  id="closingDatePayType1"
                  value="dom"
                />
                <label
                  class="form-check-label"
                  for="closingDatePayType1"
                  >{{ $t("当月日付") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDatePayType"
                  class="form-check-input"
                  type="radio"
                  id="closingDatePayType2"
                  value="eom"
                />
                <label
                  class="form-check-label"
                  for="closingDatePayType2"
                  >{{ $t("当月末") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDatePayType"
                  class="form-check-input"
                  type="radio"
                  id="closingDatePayType3"
                  value="nmd"
                />
                <label
                  class="form-check-label"
                  for="closingDatePayType3"
                  >{{ $t("翌月日付") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDatePayType"
                  class="form-check-input"
                  type="radio"
                  id="closingDatePayType4"
                  value="eonm"
                />
                <label
                  class="form-check-label"
                  for="closingDatePayType4"
                  >{{ $t("翌月末") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.closingDatePayType"
                  class="form-check-input"
                  type="radio"
                  id="closingDatePayType5"
                />
                <label
                  class="form-check-label"
                  for="closingDatePayType5"
                  >{{ $t("都度払い") }}</label>
              </div>
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">
              {{ $t("決算直後支払日") }}
            </th>
            <td class="text-left" colspan="5">
              <input
                v-model.number="form.closingDatePayDay"
                type="number"
                class="form-control input wf-60"
              />
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">
              {{ $t("支払い方法") }}
            </th>
            <td class="text-left" colspan="5">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.payMethod"
                  class="form-check-input"
                  type="radio"
                  id="payMethod1"
                  value="cash"
                />
                <label class="form-check-label" for="payMethod1">
                  {{ $t("現金") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.payMethod"
                  class="form-check-input"
                  type="radio"
                  id="payMethod2"
                  value="transfer"
                />
                <label class="form-check-label" for="payMethod2">
                  {{ $t("振込") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.payMethod"
                  class="form-check-input"
                  type="radio"
                  id="payMethod3"
                  value="bill"
                />
                <label class="form-check-label" for="payMethod3">
                  {{ $t("手形") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.payMethod"
                  class="form-check-input"
                  type="radio"
                  id="payMethod4"
                  value="check"
                />
                <label class="form-check-label" for="payMethod4">
                  {{ $t("小切手") }}
                </label>
              </div>
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">
              {{ $t("税計算法") }}
            </th>
            <td class="text-left" colspan="5">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.taxCalc"
                  class="form-check-input"
                  type="radio"
                  id="taxCalc1"
                  value="round"
                />
                <label class="form-check-label" for="taxCalc1">
                  {{ $t("四捨五入") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.taxCalc"
                  class="form-check-input"
                  type="radio"
                  id="taxCalc2"
                  value="ceil"
                />
                <label class="form-check-label" for="taxCalc2">
                  {{ $t("切り上げ") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.taxCalc"
                  class="form-check-input"
                  type="radio"
                  id="taxCalc3"
                  value="floor"
                />
                <label class="form-check-label" for="taxCalc3">
                  {{ $t("切り捨て") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.taxCalc"
                  class="form-check-input"
                  type="radio"
                  id="taxCalc4"
                  value="include"
                />
                <label class="form-check-label" for="taxCalc4">
                  {{ $t("税込") }}
                </label>
              </div>
            </td>
          </tr>
          <tr v-if="isUsePurchase">
            <th class="table-active text-left">{{ $t("請求有") }}</th>
            <td class="text-left" colspan="5">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.isClaim"
                  id="checkbox1"
                  type="checkbox"
                  class="form-check-input" />
                <label class="form-check-label" for="checkbox1">
                  {{ $t("請求有") }}
                </label>
              </div>
            </td>
          </tr>
          <tr v-if="!outsourcing">
            <th class="table-active text-left">
              {{ $t("取引関係") }}
              <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
            </th>
            <td class="text-left" colspan="5">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.isCustomer"
                  class="form-check-input"
                  type="checkbox"
                  id="iscustomer1"
                />
                <label class="form-check-label" for="iscustomer1">
                  {{ $t("得意先") }}
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.isSupplier"
                  class="form-check-input"
                  type="checkbox"
                  id="checkbox2"
                  @change="changeIsSupplier($event)"
                />
                <label class="form-check-label" for="checkbox2">
                  {{ $t("仕入先") }}
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left wf-160">
              {{ $t("材料仕入先") }}
            </th>
            <td class="text-left" colspan="5">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.isMaterialSupplier"
                  @change="changeIsMaterialSupplier($event)"
                  class="form-check-input"
                  type="checkbox"
                  id="checkbox3"
                />
                <label class="form-check-label" for="checkbox3">
                  {{ $t("材料仕入先") }}
                </label>
              </div>
            </td>
          </tr>
          <tr v-if="form.isSupplier || form.isMaterialSupplier">
            <th class="table-active text-left">{{ $t("外注工程") }}</th>
            <td class="text-left" colspan="5">
              <label for="displayColor">
                <tooltip
                  :text="$t('外注工程表示色')"
                  icon="fa-question-circle"
                  position="position-left-top"
                  :msg="$t('外注工程'+this.$appConfig.tooltipMessages.setDidplayColorOnGanttChart)"
                  :msgMaxLength="$t('外注工程'+this.$appConfig.tooltipMessages.setDidplayColorOnGanttChart).length"
                  :isDisplayColorBtn="false"
                ></tooltip>
              </label>
              <div class="display-color-wrap">
                <button
                  id="displayColor"
                  type="button"
                  class="form-control btn btn-color-circle"
                  :style="displayColorStyle"
                  @click="displayColorModalOpen()"
                >
                </button>
                <label class="col-sm-4 col-form-label">
                  {{ $t(displayColorName) }}
                </label>
              </div>
              <div>
                <p>
                  {{ $t("工程計画ルール") }}
                  <q-toggle
                    class="ml-4"
                    v-model="form.isOperativeNonRegularTime"
                    :label="$t('会社情報で設定した休日を所要日数に含める')"
                  />
                </p>
              </div>
              <div>
                <p>{{ $t("工程区分") }}</p>
                <template v-for="(item, index) in kinds">
                  <div
                    :key="`kind-${index}`"
                    class="form-check border-bottom"
                  >
                    <input
                      @change="changeMaterialSupplier($event, item.id)"
                      class="form-check-input mt-2"
                      type="checkbox"
                      :id="`kind-${index}`"
                    />
                    <label
                      class="form-check-label ml-2"
                      :for="`kind-${index}`"
                      >{{ $t(item.messageKey) }}</label>
                  </div>
                  <div
                    class="form-check form-check-inline mb-5 flex-wrap"
                    :key="`kindChildren-${index}`"
                  >
                    <template v-for="child in item.datas">
                      <label
                        class="form-check-label mt-2"
                        :for="`child-${child.id}`"
                        :key="`childLabel-${child.id}`"
                        v-if="!child.isMaterialPrepare"
                      >
                        <input
                          v-model="form.processKindIds"
                          class="form-check-input ml-3 mr-3"
                          type="checkbox"
                          :id="`child-${child.id}`"
                          :value="child.id"
                          :key="`childInput-${child.id}`"
                        />{{ $t(child.messageKey) }}
                      </label>
                    </template>
                  </div>
                </template>
              </div>
            </td>
          </tr>
          <tr v-if="isUseEDI">
            <th class="table-active text-left">
              {{ $t("会社ID") }}
            </th>
            <td class="text-left" colspan="5">
              <input
                v-model="form.email"
                type="email"
                class="form-control"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
          {{ $t("登録") }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >
          {{ $t("キャンセル") }}
        </button>
      </div>
    </template>
    <selectDisplayColorModal
      ref="selectDisplayColorModal"
      flg="modal-display-color modal-display-color-partner"
      :displayColorStyle="this.displayColorStyle"
      @modal-close="setDisplayColor">
    </selectDisplayColorModal>
  </b-modal>
</template>

<script>
import config from '@/config'
import country from '../../assets/json/country.json'
import { mapGetters } from 'vuex'
import pref from '../../assets/json/pref.json'
import selectDisplayColorModal from '@/components/selectDisplayColorModal.vue'
import tooltip from '@/components/tooltip.vue'
const form = {
  name: '',
  kana: '',
  code: '',
  partnerGroupId: '',
  zipcode: '',
  prefCode: '',
  address1: '',
  address2: '',
  address3: '',
  phoneNo: '',
  faxNo: '',
  email: '',
  closingDayType: 'eom',
  closingDay: '',
  payType: 'eom',
  payDay: '',
  closingMonth: '',
  closingDateType: 'eom',
  closingDate: '',
  closingDatePayType: 'eom',
  closingDatePayDay: '',
  payMethod: 'cash',
  isClaim: false,
  taxCalc: 'round',
  isCustomer: false,
  isSupplier: false,
  isMaterialSupplier: false,
  processKindIds: [],
  countryCode: '',
  prepareDelayNoticeDays: null,
  prepareDelayNoticeTime: '',
  deliveryDelayNoticeDays: null,
  deliveryDelayNoticeTime: '',
  isOperativeNonRegularTime: false,
  options: null,
  displayColor: config.processDisplayColors.green.val,
}
export default {
  props: {
    kinds: {
      type: Array,
      default: () => [],
    },
    outsourcing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      country: country,
      form: {
        displayColor: config.processDisplayColors.green.val,
        name: '',
        kana: '',
        code: '',
        partnerGroupId: '',
        zipcode: '',
        prefCode: '',
        address1: '',
        address2: '',
        address3: '',
        phoneNo: '',
        faxNo: '',
        email: '',
        closingDayType: 'date',
        closingDay: '',
        payType: 'dom',
        payDay: '',
        closingMonth: '',
        closingDateType: 'date',
        closingDate: '',
        closingDatePayType: 'dom',
        closingDatePayDay: '',
        payMethod: '',
        isClaim: false,
        taxCalc: '',
        isCustomer: false,
        isSupplier: false,
        isMaterialSupplier: false,
        processKindIds: [],
        countryCode: '',
        prepareDelayNoticeDays: null,
        prepareDelayNoticeTime: null,
        deliveryDelayNoticeDays: null,
        deliveryDelayNoticeTime: null,
        isOperativeNonRegularTime: false,
        options: null,
      },
      error: '',
      registering: false,
      pref: pref,
      // kinds: [],
      groups: [],
      master: {},
      isUseInventory: false,
      isUseSmallLot: false,
      isUsePurchase: false,
      isUseEDI: false,
    }
  },
  components: {
      tooltip,
      selectDisplayColorModal,
  },
  methods: {
    // モーダルを開いたときの処理
    async modalOpen(item = null) {
      // data-toggleを使うより、ここで明示的にモーダル表示させる方が良い気がする。
      try {
        this.master = []
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/masters`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.master = res.data
        this.isUseInventory = this.master.company.isUseInventory
        this.isUseSmallLot = this.master.company.isUseSmallLot
        this.isUsePurchase = this.master.company.isUsePurchase
        this.isUseEDI = this.master.company.isUseEDI
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }

      this.$refs.partnerModal.show()
      if (!item) {
        (this.form = this.mixin_deepcopy(form))
        if (this.outsourcing) this.$set(this.form, 'isSupplier', true)
        this.form.countryCode = this.userdata.countryCode
      } else {
        try {
          this.form = this.mixin_deepcopy(item)
          let kindIds = []
          this.form.processKindIds.map(kindId => {
            kindIds.push(Number(kindId))
          })
          this.$set(this.form, 'processKindIds', kindIds)

        } catch (err) {
          this.$toasted.show(err)
          this.modalClose()
        }
      }
      try {
        const groups = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/partner/groups`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        // this.kinds = kinds.data
        this.groups = groups.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$refs.partnerModal.hide()
      this.$emit('modalClose')
    },
    // 外注工程のカテゴリーをcheckしたときの処理
    changeMaterialSupplier(e, id) {
      let filterKinds = this.kinds.filter(item => item.id === id)
      if (e.target.checked) {
        filterKinds[0].datas.map(item => {
          this.form.processKindIds.push(item.id)
        })
        const dupKinds = this.form.processKindIds.filter((x, i, self) => {
          return self.indexOf(x) === i
        })
        this.form.processKindIds = dupKinds
      } else {
        const dupKinds = this.form.processKindIds.filter((x) => {
          let removeFlag = false
          filterKinds[0].datas.map(item => {
            if (item.id === x) removeFlag = true
          })
          return !removeFlag
        })
        this.form.processKindIds = dupKinds
      }
    },
    // 材料仕入先がcheckされたら取引関係の仕入先もcheckする処理
    changeIsMaterialSupplier(e) {
      if (e.target.checked) {
        this.form.isSupplier = true
        this.form.processKindIds.push(108)
      } else {
        this.form.processKindIds.map((id, idx) => {
          if (id == 108) this.form.processKindIds.splice(idx, 1)
        })
      }
    },
    // 取引関係の仕入先のcheckが外れたら材料仕入先もcheckを外す処理
    changeIsSupplier(e) {
      if (!e.target.checked) this.form.isMaterialSupplier = false
    },
    async register() {
      try {
        // バリデーション
        if (!this.form.name)
          return (this.error = this.$t('取引先名') + this.$t('必須メッセージ'))
        if (!this.form.isCustomer && !this.form.isSupplier)
          return (this.error = this.$t('取引関係のどちらかかもしくは両方を選択して下さい'))
        // if (this.error) this.error = ''
        this.registering = true
        // リクエストパラメーターを定義
        let params = {}
        for (let key of Object.keys(this.form)) {
          if (key === 'processKindIds') {
            if (this.form.isSupplier && this.form[key].length !== 0) {
              const str = this.mixinRegularToString(this.form[key])
              params[key] = str
            } else {
              params[key] = ''
            }
          } else if (key === 'partnerGroupId') {
            params[key] = this.form[key] ? String(this.form[key]) : ''
          } else if (key === 'isClaim' || key === 'isCustomer' || key === 'isSupplier' || key === 'isMaterialSupplier' || key === 'isOperativeNonRegularTime') {
            params[key] = this.form[key]
          } else if (key === 'tax') {
            params[key] = this.form[key] ? this.form[key] : 10
          } else if (key === 'options') {
            params[key] = this.form[key] ? this.form[key] : {}
          } else {
            params[key] = this.form[key] ? this.form[key] : ''
          }
        }

        let method = 'post'
        if (params.id) method = 'put'
        await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/partner`,
          data: params,
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.$refs.partnerModal.hide()
        this.$emit('registed')
      } catch (err) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.registering = false
    },
    displayColorModalOpen() {
      this.$refs.selectDisplayColorModal.modalOpen()
    },
    setDisplayColor(data) {
      if (data.hex) {
        this.form.displayColor = data.hex
      }
    },
  },
  watch: {
    'form.zipcode': function(zip) {
      let _this = this.form
      if (_this.countryCode != 'JP') return
      try {
        // NOTE: html上で直接scriptを呼び出している
        // eslint-disable-next-line no-undef
        new YubinBango.Core(zip, function(addr) {
          _this.prefCode = _this.prefCode ? _this.prefCode : addr.region_id ? 'JP-' + (addr.region_id < 10 ? '0' + addr.region_id : addr.region_id) : '' // 都道府県ID
          _this.address1 = _this.address1 ? _this.address1 : addr.locality // 市区町村
          _this.address2 = _this.address2 ? _this.address2 : addr.street // 町域
        })
      } catch (err) {
        // console.log(err)
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
    displayColorName() {
      if (!this.form.displayColor) return config.processDisplayColors.green
      return Object.values(config.processDisplayColors).find(color => this.form.displayColor === color.val)?.name
    },
    displayColorStyle() {
      if (!this.form.displayColor)
        return {'background-color': '', 'border-color': ''}
      return {
        'background-color': this.form.displayColor,
        'border-color': this.form.displayColor,
      }
    },

  },
}
</script>

<style lang="scss" scoped>
#partnerModal {
  .modal-dialog {
    max-width: 100rem;
  }
}
.display-color-wrap {
  display: inline-block;
  margin: 0 1rem;
}
</style>
